
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopunecabs() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Cabs',
        heading: 'Skyline Cabs: Mumbai to Pune Cabs',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Mumbai to Pune Cabs for a stress-free travel experience. Whether you are returning home, heading to Pune for business, or planning a weekend getaway, our clean and well-equipped cabs ensure a smooth and timely journey. Driven by professional chauffeurs and backed by 24/7 customer support, we provide safe, affordable, and convenient cab services from Mumbai to Pune. Book with Skyline Cabs today and enjoy a seamless ride every time.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs offers affordable and transparent taxi fares for your journey from Mumbai to Pune. Our pricing includes all taxes, tolls, and fuel charges with no hidden costs. Choose from a range of vehicles including sedans, Ertiga, and Innova."
    },
    {
      "name": "Mumbai to Pune Car Rental",
      "description": "Rent a car from Mumbai to Pune with Skyline Cabs. We offer a variety of vehicles for your convenience, including luxury cars, sedans, and SUVs for a comfortable journey. Our car rental services are reliable and affordable."
    },
    {
      "name": "Mumbai to Pune Cab Charges",
      "description": "Skyline Cabs provides clear and affordable pricing for your Mumbai to Pune journey. Our cab charges cover all fees such as tolls, fuel, and driver charges. We offer competitive rates for a seamless travel experience."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book your cab from Mumbai to Pune with Skyline Cabs for a hassle-free ride. Choose from a fleet of vehicles including sedans, SUVs, and luxury cars, available at competitive rates. We ensure on-time pickups and professional drivers."
    },
    {
      "name": "Cab Service from Mumbai to Pune",
      "description": "Skyline Cabs provides reliable cab services from Mumbai to Pune. Whether you need a one-way trip or round trip, our professional drivers and comfortable vehicles ensure a safe and pleasant journey."
    },
    {
      "name": "Car Hire from Mumbai to Pune",
      "description": "Looking for a car hire service from Mumbai to Pune? Skyline Cabs offers flexible and affordable car hire options with a wide selection of vehicles, including sedans, Ertiga, and Innova, all driven by professional chauffeurs."
    },
    {
      "name": "Mumbai to Pune by Taxi",
      "description": "Book a taxi from Mumbai to Pune with Skyline Cabs for a smooth and stress-free travel experience. Our fleet includes various vehicles like sedans, Ertiga, and Innova for a comfortable and reliable ride."
    },
    {
      "name": "Mumbai to Pune Rental Car",
      "description": "Rent a car for your Mumbai to Pune journey with Skyline Cabs. We provide a range of well-maintained vehicles, from sedans to SUVs, all driven by experienced drivers for a seamless travel experience."
    },
    {
      "name": "Mumbai to Pune Ertiga Car Rental",
      "description": "Rent an Ertiga for your journey from Mumbai to Pune with Skyline Cabs. The Ertiga offers ample space and comfort for families and groups, making it a great choice for intercity travel."
    },
    {
      "name": "Mumbai to Pune Innova Crysta",
      "description": "Travel in luxury with an Innova Crysta from Mumbai to Pune. Skyline Cabs offers this spacious and comfortable vehicle for a smooth and premium travel experience."
    },
    {
      "name": "Mumbai to Pune Sedan Cab Fare",
      "description": "Skyline Cabs offers competitive rates for sedan cabs from Mumbai to Pune. Our pricing includes all costs such as fuel, tolls, and driver charges, providing you with transparent and affordable fares."
    },
    {
      "name": "Mumbai to Pune One Way Cab",
      "description": "Book a one-way cab from Mumbai to Pune with Skyline Cabs for a convenient and affordable option. Our fleet of sedans, Ertiga, and Innova vehicles ensure a comfortable ride with professional drivers."
    },
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs provides fair and transparent taxi fares for your trip from Mumbai to Pune. Our rates include all applicable charges, ensuring no hidden costs."
    },
    {
      "name": "Mumbai to Pune Cab Charges",
      "description": "Our cab charges from Mumbai to Pune are competitive, clear, and all-inclusive. Book a cab with Skyline Cabs for a budget-friendly journey without any surprises."
    },
    {
      "name": "Mumbai to Pune Cab Fare",
      "description": "Skyline Cabs offers affordable and clear fare options for your Mumbai to Pune ride. We provide different vehicle choices to match your budget and travel needs."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Skyline Cabs makes it easy to book your cab from Mumbai to Pune. Our user-friendly booking platform and professional service ensure a smooth journey every time."
    },
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Skyline Cabs offers the cheapest cab service in Mumbai for your travel needs. We provide reliable and affordable rides, with transparent pricing and no hidden fees."
    },
    {
      "name": "Mumbai Cab Service for Outstation",
      "description": "Looking for outstation travel from Mumbai? Skyline Cabs offers affordable and reliable cab services for outstation trips, including Mumbai to Pune, with a range of vehicles and competitive fares."
    },
    {
      "name": "Mumbai to Pune Innova Crysta",
      "description": "Travel from Mumbai to Pune in style with the Innova Crysta. Skyline Cabs provides this spacious and comfortable vehicle for a smooth, premium travel experience."
    },
    {
      "name": "Mumbai to Pune Ertiga Cab Service",
      "description": "Skyline Cabs offers Ertiga cab services from Mumbai to Pune. Perfect for families and groups, this vehicle offers plenty of space and comfort, making your journey enjoyable."
    },
    {
      "name": "Mumbai to Pune Taxi Service",
      "description": "Book a reliable taxi service from Mumbai to Pune with Skyline Cabs. Our well-maintained fleet, including sedans, Ertiga, and Innova, is available for one-way, round trip, or long-term travel."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
    ["Mumbai to Pune Cab Charges", "Mumbai to Pune Cab Booking"],
    ["Cab Service from Mumbai to Pune", "Car Hire from Mumbai to Pune"],
    ["Mumbai to Pune by Taxi", "Mumbai to Pune Rental Car"],
    ["Mumbai to Pune Ertiga Car Rental", "Mumbai to Pune Innova Crysta"],
    ["Mumbai to Pune Sedan Cab Fare", "Mumbai to Pune One Way Cab"],
    ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Cab Charges"],
    ["Mumbai to Pune Cab Fare", "Mumbai to Pune Cab Booking"],
    ["Cheapest Cab Service in Mumbai", "Mumbai Cab Service for Outstation"],
    ["Mumbai to Pune Innova Crysta", "Mumbai to Pune Ertiga Cab Service"],
    ["Mumbai to Pune Taxi Service", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides timely and reliable cab services for your Mumbai to Pune journey. Whether you're traveling for business, leisure, or an airport transfer, we ensure a seamless, punctual ride from start to finish. Our professional drivers and well-maintained vehicles guarantee a smooth trip every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Experience comfort during your journey from Mumbai to Pune in our spacious and air-conditioned vehicles. We offer a variety of vehicle options, from sedans to SUVs, ensuring that your travel is as comfortable as possible, with enough space for luggage and passengers."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Skyline Cabs employs highly trained and professional drivers who are well-versed with the Mumbai to Pune route. Our drivers ensure a smooth, safe, and pleasant ride, providing courteous service and handling the road with expertise, so you can relax and enjoy the journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Our Mumbai to Pune cab services come at competitive and affordable prices. Skyline Cabs ensures transparency with no hidden fees. You’ll always know the fare upfront, and our pricing structure is designed to offer great value without compromising on quality or comfort."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs is available round-the-clock for your Mumbai to Pune travel needs. Whether you need an early morning pickup or a late-night ride, our services are available 24/7 to accommodate your schedule and provide a convenient, stress-free travel experience."
    },
    {
        "WhyChooseheading": "Fleet Options to Suit Every Need",
        "WhyChoosedescription": "No matter your group size or travel preferences, Skyline Cabs offers the right vehicle for you. From comfortable sedans for solo travelers to spacious SUVs for families or groups, we ensure that you travel in style and comfort on your journey from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking a cab for your Mumbai to Pune journey is quick and easy with Skyline Cabs. Simply use our user-friendly mobile app or website to book your ride, receive instant booking confirmation, and track your driver in real-time for a hassle-free experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Guaranteed",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are GPS-enabled, and our drivers undergo rigorous background checks. You can rest assured knowing that you’re in good hands, and our drivers will ensure your journey from Mumbai to Pune is as secure and smooth as possible."
    }
]














    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Mumbai to Pune with Skyline Cabs?',
            answer:
                'Booking your ride is simple! Just visit our website or use the mobile app. Select Mumbai as your pickup point and Pune as your destination. Choose from a variety of vehicle options and confirm your booking in minutes.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Mumbai to Pune travel?',
            answer:
                'We offer a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Pick a vehicle that suits your comfort, group size, and travel preferences.',
        },
        {
            id: 3,
            question: 'Are the fares for Mumbai to Pune fixed?',
            answer:
                'Yes, our pricing is transparent and fixed. The fare includes tolls, driver charges, and taxes, so there are no hidden costs. The total price will be visible upfront before you confirm your booking.',
        },
        {
            id: 4,
            question: 'Can I book a round-trip cab from Mumbai to Pune?',
            answer:
                'Yes, you can easily book both one-way and round-trip rides. If you’re returning the same day or another day, simply add your return details while booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Mumbai to Pune?',
            answer:
                'The journey usually takes about 3 to 4 hours depending on traffic. Our experienced drivers know the best routes and ensure you reach your destination in a timely and safe manner.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced for long-distance trips like Mumbai to Pune?',
            answer:
                'Yes, all our drivers are well-trained, experienced, and background-verified. They are familiar with the Mumbai to Pune route and ensure a smooth and safe ride.',
        },
        {
            id: 7,
            question: 'Can I book a cab for Mumbai to Pune Airport transfer?',
            answer:
                'Absolutely! We provide reliable airport transfers from Mumbai to both Domestic and International terminals. Share your flight details and we will ensure timely airport drop-offs.',
        },
        {
            id: 8,
            question: 'Are the cabs clean and comfortable?',
            answer:
                'Yes, all Skyline cabs are thoroughly cleaned, sanitized, and fully air-conditioned to provide a comfortable ride. Your safety and comfort are our top priorities.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my booking if my plans change?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, app, or by contacting our customer support team. We offer flexibility in case of any change in your travel plans.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for Mumbai to Pune travel?',
            answer:
                'Skyline Cabs is known for punctuality, cleanliness, experienced drivers, and transparent pricing. Whether you’re traveling for business, leisure, or airport transfers, we ensure a smooth, safe, and comfortable ride every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Arvind Patil",
            rating: 5,
            review: "I booked a cab from Mumbai to Pune for a business trip. The service was excellent, the driver was professional, and the car was spotless. I reached Pune ahead of schedule. Skyline Cabs truly lives up to its reputation!"
        },
        {
            name: "Miss. Neha Sharma",
            rating: 4,
            review: "I had a pleasant trip from Mumbai to Pune with Skyline Cabs. The car was comfortable, and the driver was friendly and well-informed. A great experience overall, although the AC could have been a bit cooler. But otherwise, a solid service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pune-cab.jpg",
  "description": "Book Mumbai to Pune cabs with Skyline Cabs for a smooth, safe, and timely journey. Choose from AC sedans, SUVs, or premium cars driven by professional drivers — 24/7 service available for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8217"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pune-cabs"
  }
};




     
      

    return (
        <div>

<Helmet>
  <title>Mumbai to Pune Cabs | 24/7 AC Taxi Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune cabs with Skyline Cabs for a smooth, safe, and timely journey. Choose from AC sedans, SUVs, or premium cars driven by professional drivers — 24/7 service available for one-way or round trips." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Cabs, Cab from Mumbai to Pune, One-Way Taxi Mumbai to Pune, Round Trip Cab Mumbai to Pune, AC Cab Mumbai to Pune, SUV Taxi Mumbai to Pune, Skyline Cabs Mumbai to Pune, Affordable Cabs Mumbai to Pune, 24/7 Taxi Mumbai to Pune, Online Cab Booking Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopunecabs;